import './styles/SmartPicsImg.scss';


function SmartPicsImg(props) {
    const {
        smartPicSrc,
        label,
    } = props;


    return (
    <li>
        <div className="examplesListImg">
            <video autoPlay muted loop playsInline>
                <source src={smartPicSrc} type="video/mp4" />
            </video>
        </div>
        <p className="label1">{label}</p>
    </li>
    )
}
            
export default SmartPicsImg;